var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckmarkDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkmark_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M3.161,3.98a.817.817,0,0,1-.579-.24L-.76.4A.819.819,0,0,1-.76-.76.819.819,0,0,1,.4-.76L3.74,2.582a.819.819,0,0,1-.579,1.4Z",
    transform: "translate(1 3.785)",
    fill: "#5B788F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M-.181,6.765a.817.817,0,0,1-.579-.24.819.819,0,0,1,0-1.158L5.366-.76a.819.819,0,0,1,1.158,0A.819.819,0,0,1,6.525.4L.4,6.525A.817.817,0,0,1-.181,6.765Z",
    transform: "translate(4.342 1)",
    fill: "#5B788F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkDark);
export default __webpack_public_path__ + "static/media/icon_checkmark_dark.24ac18e306106910146287dbc382f130.svg";
export { ForwardRef as ReactComponent };